import * as Yup from 'yup'

export const observacaoSchema = Yup.object({
  observacao: Yup.string().trim().required('Observação é obrigatória'),
})
